module.exports = __webpack_public_path__ + "310c4b728a47dde0611b2c182584f2e9.svg";